<template>
    <div class="light-toggle" :class="{ 'light-toggle--active': lightMode }">
        <ProIcon icon="sun" class="light-toggle__icon" />
        <ProSwitch v-fathom-event:click="['3E8R7TTS']" :value="lightMode" @input="toggleLightMode()" aria-label="Toggle light mode"></ProSwitch>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProSwitch from "@/components/ProSwitch";

export default {
    components: { ProSwitch },

    computed: {
        ...mapGetters({
            lightMode: "handbook/getLightMode",
        }),
    },

    methods: {
        toggleLightMode() {
            this.$store.commit("handbook/setLightMode", !this.lightMode);
        },
    },
};
</script>

<style lang="scss">
.light-toggle {
    display: flex;
    align-items: center;
    margin: 8px 0;
    position: relative;
    $unit: 24px;
    color: var(--hb-font-color);

    &--active {
        .light-toggle__icon {
            svg {
                fill: #242424;
                transition: left 150ms cubic-bezier(0, 0.55, 0.45, 1) 50ms;
            }
        }
    }

    &__icon {
        display: block;
        margin-right: 8px;

        svg {
            top: 50%;
            fill: #7e7e7e;
            transition: left 150ms cubic-bezier(0, 0.55, 0.45, 1) 50ms;
        }
    }
}
</style>
